import { useState, useCallback } from 'react';

const KEY = 'sidebarCollapsed';

function readInitial() {
  try { return localStorage.getItem(KEY) === '1'; }
  catch { return false; }
}

// Persists the sidebar's collapsed/expanded state across reloads. No existing
// localStorage-preference pattern in this codebase — kept as simple as the app's
// other ad hoc persisted flags (e.g. the SQF after-production dismiss set).
export default function useSidebarCollapsed() {
  const [collapsed, setCollapsedState] = useState(readInitial);

  const setCollapsed = useCallback((value) => {
    setCollapsedState(value);
    try { localStorage.setItem(KEY, value ? '1' : '0'); } catch {}
  }, []);

  const toggle = useCallback(() => setCollapsed(!collapsed), [collapsed, setCollapsed]);

  return { collapsed, setCollapsed, toggle };
}
